import React from 'react';
import { Menu, Search, Bell, Sun, Moon } from 'lucide-react';
import useIsDesktop from '../hooks/useIsDesktop';

function Topbar({
  pageTitle,
  breadcrumb,
  onOpenMobileMenu,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  notificationCount = 0,
  onNotificationsClick,
  theme,
  onToggleTheme,
}) {
  const isDesktop = useIsDesktop();
  const ThemeIcon = theme === 'dark' ? Sun : Moon;

  return (
    <header style={styles.bar}>
      <div style={styles.left}>
        {!isDesktop && (
          <button onClick={onOpenMobileMenu} style={styles.iconBtn} aria-label="Open menu">
            <Menu size={20} />
          </button>
        )}
        <div>
          {breadcrumb && <p style={styles.breadcrumb}>{breadcrumb}</p>}
          <h1 style={styles.title}>{pageTitle}</h1>
        </div>
      </div>

      <div style={styles.right}>
        {onSearchChange && isDesktop && (
          <div style={styles.searchWrap}>
            <Search size={15} color="var(--color-muted)" />
            <input
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={searchPlaceholder || 'Search...'}
              className="input-field"
              style={styles.searchInput}
            />
          </div>
        )}

        {onNotificationsClick && (
          <button onClick={onNotificationsClick} style={styles.iconBtn} aria-label="Notifications">
            <Bell size={18} />
            {notificationCount > 0 && <span style={styles.notifDot}>{notificationCount}</span>}
          </button>
        )}

        <button
          onClick={onToggleTheme}
          style={styles.iconBtn}
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          <ThemeIcon size={18} />
        </button>
      </div>
    </header>
  );
}

const styles = {
  bar: {
    position: 'sticky',
    top: 0,
    zIndex: 40,
    backgroundColor: 'var(--color-surface)',
    borderBottom: '1px solid var(--color-border)',
    padding: '0 20px',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: 0,
  },
  breadcrumb: {
    fontSize: '12px',
    color: 'var(--color-muted)',
    margin: '0 0 2px',
  },
  title: {
    fontSize: '17px',
    fontWeight: 700,
    color: 'var(--color-ink)',
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,
  },
  searchWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    border: '1px solid var(--color-border)',
    borderRadius: '10px',
    backgroundColor: 'var(--color-bg-alt)',
    width: '220px',
  },
  searchInput: {
    border: 'none',
    background: 'transparent',
    fontSize: '13px',
    color: 'var(--color-ink)',
    width: '100%',
  },
  iconBtn: {
    position: 'relative',
    width: '38px',
    height: '38px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid var(--color-border)',
    borderRadius: '10px',
    backgroundColor: 'transparent',
    color: 'var(--color-ink-soft)',
    cursor: 'pointer',
  },
  notifDot: {
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    backgroundColor: 'var(--color-danger)',
    color: '#fff',
    fontSize: '10px',
    fontWeight: 700,
    borderRadius: '999px',
    padding: '1px 5px',
    minWidth: '16px',
    textAlign: 'center',
  },
};

export default Topbar;
